/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useEffect } from "react";
import { LAYER_TYPE } from "../../../actions/Layers/constants";
import mq from "../../../constants/mediaqueries";
import { useLayerModal } from "../../../hooks";
import LayerAutoComplete from "../../Forms/LayerAutoComplete";
import { useSwitchTabContext } from "./fields/useSwitchTab";
import { CreateLayer } from "./Layer/CreateLayer";

export default function FindLayerBox() {
    const {
        layerModalOpen,
        onCreateLayer,
        setValue,
        onClose,
        setLayerSelect,
        layerConfig,
        layer,
        setLayer,
    } = useLayerModal();

    const { filter } = useSwitchTabContext();

    useEffect(() => {
        if (filter.layer_type) {
            setLayer((prev) => ({ ...prev, type: filter.layer_type as LAYER_TYPE }));
        }
    }, [filter.layer_type]);

    if (!layerConfig) {
        return null;
    }

    return (
        <div css={mq({ flexGrow: [1, 1, 1, "unset"], maxWidth: ["100%", "20rem"], minWidth: "250px" })}>
            <CreateLayer
                modal
                isOpen={layerModalOpen}
                onClose={onClose}
                onSubmit={onCreateLayer}
                layer={layer}
                setLayerSelect={setLayerSelect}
                setValue={setValue}
                disableSaveButton={!layer.label || !layer.type}
            />

            <div className="w-100 d-flex align-items-center justify-content-between justify-content-lg-start">
                <div className="w-100" css={css`z-index: 100;`}>
                    <LayerAutoComplete
                        type={null}
                        layer={layer}
                        setLayer={setLayerSelect}
                        label_format={layerConfig.label_format}
                        invalid_hint={layerConfig.invalid_hint}
                        creatable={layerConfig?.is_creatable !== false}
                    />
                </div>
            </div>
        </div>
    );
}
